/**
 * Shared theme constants for the Duties feature
 * Centralizes colour palette and common design tokens
 */

/**
 * Core colour palette used across all Duties components
 */
export const DUTIES_COLOURS = {
  /** Primary text colour - #000000 */
  primary: '#000000',
  /** Secondary text colour - #545454 */
  secondary: '#545454',
  /** Background colour - #ffffff */
  background: '#ffffff',
  /** Light grey background - #FAFAFA */
  backgroundLight: '#FAFAFA',
  /** Light border colour - rgba(0, 0, 0, 0.08) */
  borderLight: 'rgba(0, 0, 0, 0.08)',
  /** Medium border colour - rgba(0, 0, 0, 0.12) */
  borderMedium: 'rgba(0, 0, 0, 0.12)',
  /** Standard border colour - #E5E5E5 */
  border: '#E5E5E5',
  /** Scroll button disabled state - #9e9e9e */
  scrollButtonDisabled: '#9e9e9e',
  /** Primary action colour - #1976d2 */
  primaryAction: '#1976d2',
  /** Primary action hover - #1565c0 */
  primaryActionHover: '#1565c0'
} as const;

/**
 * Standard spacing values
 */
export const DUTIES_SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px'
} as const;

/**
 * Border radius values
 */
export const DUTIES_RADIUS = {
  sm: '8px',
  md: '12px'
} as const;
